import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

/**
 * Hook to fetch the current user's details from the S2 API and check
 * whether they are active staff.
 */
export function useMyDetails() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data, isPending, isError } = useQuery({
		queryKey: ["myDetails"],
		queryFn: () => callPymbleApi(instance, "GET", "my/details/"),
		enabled: isAuthenticated,
	});

	const hasAdminAccess = data?.active?.staff === true;

	return { isLoading: isPending, isError, hasAdminAccess };
}
